<script setup>
import { ref, onMounted } from 'vue'

import ToastContainer from '@/components/ToastContainer.vue'

const theme = ref('light')

const applyTheme = isDark => {
  theme.value = isDark ? 'dark' : 'light'
  document.documentElement.classList.toggle('dark', isDark)
}

onMounted(() => {
  const mql = window.matchMedia('(prefers-color-scheme: dark)')
  applyTheme(mql.matches)
  mql.onchange = e => applyTheme(e.matches)
})
</script>

<template>
  <div class="w-full h-full min-h-screen antialiased" :class="theme">
    <router-view />
    <ToastContainer />
  </div>
</template>
